/**
 * Esquemas Zod para validación de datos
 * Todos los esquemas deben ser exportados desde aquí
 */

import { z } from "zod";

// Esquemas base
export const idSchema = z.string().uuid();

export const timestampSchema = z.number().int().positive();

export const baseEntitySchema = z.object({
  id: idSchema,
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

// Esquemas de paginación
export const paginationParamsSchema = z.object({
  page: z.number().int().positive().default(1),
  limit: z.number().int().positive().max(100).default(10),
});

// Tipos inferidos de esquemas
export type PaginationParams = z.infer<typeof paginationParamsSchema>;

